/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Gender_LabelInputs */



/**
* | output |
* | --- |
* | "Gender" |
*
* @param {Voice_Manager_Gender_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_gender_label = /** @type {((inputs?: Voice_Manager_Gender_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Gender_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Genre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschlecht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Genere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Género")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("性别")
	if (locale === "ja") return /** @type {LocalizedString} */ ("性別")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gênero")
	return /** @type {LocalizedString} */ ("Gender")
});